import React from 'react';
import Row from 'react-bootstrap/Row';

interface NoResultsProps {
    searchTerms: string;
}

const NoResults: React.FC<NoResultsProps> = ({ searchTerms }) => {
    return (
        <Row className="font-weight-normal h5 justify-content-center p-4">
            <p className="p-4">
                {'Sorry, we were not able to find any results'}
                {!!searchTerms && (
                    <span>
                        {' for '}
                        <strong>{searchTerms}</strong>
                    </span>
                )}
            </p>
            <ul className="p-4 text-secondary">
                <li className="p-1">{'Double-check your search for typos or spelling errors.'}</li>
                <li className="p-1">{'Try using the filters on this page.'}</li>
                <li className="p-1">
                    {"The course you're searching for may be discontinued or not yet in our catalog."}
                </li>
                <li className="p-1">{'Try reloading the page.'}</li>
            </ul>
        </Row>
    );
};

export { NoResults };
